import { combineReducers } from 'redux';
import AuthReducer from 'src/modules/auth/store/authReducer';
import AppReducer from 'src/modules/app/store/appReducer';
import PublicReducer from 'src/modules/onBoarding/store/publicReducer';

const createRootReducer = (routerReducer) =>
  combineReducers({
    router: routerReducer,
    app: AppReducer,
    auth: AuthReducer,
    public: PublicReducer,
  });

export default createRootReducer;